import {createSlice} from "@reduxjs/toolkit";
import {fetchScreens} from "./screenThunks";
import {activateSupportPlugin} from "../config/configThunks";

export const screenSlice = createSlice({
    name: 'screen',
    initialState: {
        screens: [],
        activeScreen: 'home-page',
        loading: true,
        error: null,
    },
    reducers: {
        setScreens: (state, action) => {
            state.screens = action.payload;
            state.loading = false;
            state.error = null;
        },
        setActiveScreen: (state, action) => {
            state.activeScreen = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchScreens.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchScreens.fulfilled, (state, action) => {
                state.loading = false;
                state.screens = action.payload;
            })
            .addCase(fetchScreens.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(activateSupportPlugin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(activateSupportPlugin.fulfilled, (state, action) => {
                state.loading = false;
                state.activeScreen = 'home-page';
            })
            .addCase(activateSupportPlugin.rejected, (state, action) => {
                state.loading = true;
                state.error = null;
            })
    }
});
export const {setScreens, setActiveScreen, setLoading, setError} = screenSlice.actions;
export default screenSlice.reducer;